import React from "react";
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";
import { useIntl } from 'react-intl';
import clsx from "clsx";

import styles from "./heroSection.module.scss"

const HeroSection = ({
  heroHeading,
  heroSubheading,
  heroImage,
  height = 320,
  lazyload = true,
  className
}) => {
  const intl = useIntl();

  const defaultImgixProps = {
    className: styles.heroSection__background,
    src: heroImage.url,
    alt: heroImage.alt ? heroImage.alt : 'Hero image',
    sizes: '100vw',
    imgixParams: { auto: 'compress,format' }
  };

  return (
    <div className={clsx(styles.heroSection__container, className)} style={{ height: `${height}px` }}>
      {lazyload && (
        <Imgix
          {...defaultImgixProps}
          className={`${defaultImgixProps.className} lazyload`}
          attributeConfig={{
            src: 'data-src',
            srcSet: 'data-srcset',
            sizes: 'data-sizes',
          }}
          htmlAttributes={{
            src: buildURL(heroImage.url, {
              auto: 'compress,format',
              blur: 50,
              w: 300
            }),
          }}
        />
      )}
      {!lazyload && <Imgix {...defaultImgixProps} />}
      <div
        className={styles.heroSection__wrapper}
        style={{ height: `${height}px` }}
      >
        {heroHeading && (
          <h1 className={styles.heroSection__heading}>{intl.formatMessage({ id: heroHeading })}</h1>
        )}
        {heroSubheading && (
          <h2 className={styles.heroSection__subHeading}>{intl.formatMessage({ id: heroSubheading })}</h2>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
